import React from 'react';
import { motion } from 'framer-motion';
import { useReveal, useBentoGlow } from '../hooks/useScrollReveal';
import '../styles/About.css';

const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

const About = () => {
    const [ref, isVisible] = useReveal();
    const glowRef = useBentoGlow();

    const details = [
        { id: 'detail1', label: 'Education', value: 'UPN Veteran Jawa Timur', sub: 'Informatics Engineering', icon: '/upn.webp' },
        { id: 'detail2', label: 'Organization', value: 'Himatifa Advokesma', sub: 'Active Member', icon: '/himatifa.webp' },
        { id: 'detail3', label: 'Achievement', value: 'Semi Final INJECTION', sub: 'at Institut Teknologi Sepuluh Nopember', icon: '/epw.webp' },
        { id: 'detail4', label: 'Internship', value: 'PT. Laxo Global Akses', sub: 'Field Technician & NOC', icon: '/laxo.webp' },
    ];

    return (
        <section id="about" className="about" ref={ref}>
            <div className="container" ref={glowRef}>
                {isVisible && (
                    <motion.div
                        className="about-grid"
                        initial="hidden"
                        animate="visible"
                        variants={{ visible: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } } }}
                    >
                        {/* Header Cell */}
                        <motion.div className="bento-card section-header-card about-header" variants={fadeUp}>
                            <span className="section-label">About</span>
                            <h2 className="section-heading">
                                Crafting Digital<br />
                                Experiences with <span className="gradient-text">Purpose</span>
                            </h2>
                            <p className="section-desc">
                                A glimpse into who I am and what drives me forward.
                            </p>
                        </motion.div>

                        {/* Bio Card */}
                        <motion.div className="bento-card about-bio" variants={fadeUp} transition={{ duration: 0.5 }}>
                            <span className="info-label">Background</span>
                            <h3>Who I Am</h3>
                            <p>
                                I'm an Informatics student at UPN Veteran Jawa Timur with a deep passion for
                                full-stack development, networking, and IoT systems. I thrive on turning complex
                                problems into elegant, user-centric solutions. Currently active in Himatifa
                                Advokesma and continuously expanding my skills.
                            </p>
                        </motion.div>

                        {/* Photo Card */}
                        <motion.div className="bento-card about-photo" variants={fadeUp} transition={{ duration: 0.5 }}>
                            <img
                                src="/nanda.webp"
                                alt="Nanda"
                                onError={(e) => { e.target.src = '/priyoga.webp'; }}
                            />
                            <div className="photo-overlay">
                                <h4>Nanda</h4>
                                <p>Full Stack Developer & IoT Enthusiast</p>
                            </div>
                        </motion.div>

                        {/* Detail Cards */}
                        {details.map((item) => (
                            <motion.div key={item.id} className={`bento-card about-detail ${item.id}`} variants={fadeUp} transition={{ duration: 0.5 }}
                                whileHover={{ y: -4, transition: { duration: 0.2 } }}
                            >
                                <div className="detail-icon">
                                    <img src={item.icon} alt={item.label} onError={(e) => { e.target.style.display = 'none'; }} />
                                </div>
                                <div>
                                    <span className="info-label">{item.label}</span>
                                    <div className="detail-value">{item.value}</div>
                                    <div className="detail-sub">{item.sub}</div>
                                </div>
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </div>
        </section>
    );
};

export default About;